export default (objectToCopy) => {
  if (!objectToCopy) return {};
  return JSON.parse(JSON.stringify(objectToCopy));
};
